import {CrudModel} from '@ngx-ivengi/crud';
import {IFormSelectOption} from '@brands-compart/form-wizard';

export class User extends CrudModel implements IFormSelectOption {
  public enabled: boolean = true;
  public email: string;
  public username: string;
  public password: string;
  public passwordConfirmation: string;
  public firstName: string;
  public lastName: string;
  public phoneNr: string;
  public roles: string[] = [];

  public setEnabled(enabled: boolean): User {
    if (typeof enabled === 'boolean') {
      this.enabled = enabled;
    }
    return this;
  }

  public getUsername(): string {
    return this.username;
  }

  public setUsername(username: string): User {
    if(typeof username === 'string') {
      this.username = username;
    }
    return this;
  }

  public setPassword(password: string): User {
    if(typeof password === 'string') {
      this.password = password;
    }
    return this;
  }

  public getPassword(): string {
    return this.password;
  }

  public setFirstName(firstName: string): User {
    if(typeof firstName === 'string') {
      this.firstName = firstName;
    }
    return this;
  }

  public getFirstName(): string {
    return this.firstName;
  }

  public setLastName(lastName: string): User {
    if(typeof lastName === 'string') {
      this.lastName = lastName;
    }
    return this;
  }

  public getLastName(): string {
    return this.lastName;
  }

  public setPhoneNr(phoneNr: string): User {
    if(typeof phoneNr === 'string') {
      this.phoneNr = phoneNr;
    }
    return this;
  }

  public getPhoneNr(): string {
    return this.phoneNr;
  }

  public setEmail(email: string): User {
    if(typeof email === 'string') {
      this.email = email;
    }
    return this;
  }

  public getEmail(): string {
    return this.email;
  }

  public setRoles(roles: string[]): User {
    if(roles instanceof Array) {
      this.roles = roles.filter((item) => {
        return (typeof item === 'string');
      });
    }
    return this;
  }

  public getRoles(): string[] {
    return this.roles;
  }

  public fromResponse(response: any): void {
    if(response) {
      this
        .setId(response.id)
        .setEnabled(response.enabled)
        .setUsername(response.username)
        .setFirstName(response.firstName)
        .setLastName(response.lastName)
        .setPhoneNr(response.phoneNr)
        .setEmail(response.email)
        .setRoles(response.roles);
    }
  }

  toKeyValueOption(): {label: string; value: any, disabled?: boolean} {
    return {
      label: `${this.firstName} ${this.lastName}${(!this.enabled) ? '! (uitgeschakeld)' : ''}`,
      value: this.id
    };
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/user/user.model.ts